import { SorterRulePreview } from 'src/components/sorter-rule-preview';

export default SorterRulePreview;
